export default function HeaderCloseMenuCategoriesIcon({...props}) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M25.3337 6.66666L6.66699 25.3333M6.66701 6.66666L25.3337 25.3333" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
